/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponCreateRequest {
  acquisition?: boolean;
  couponType?: number;
  couponUsageTypeId?: number;
  dateExpired?: Date;
  emailRestrictions?: Array<string>;
  enabled?: boolean;
  freeShipping?: number;
  freebieCount?: number;
  freebieMessage?: string;
  glampoints?: number;
  influencerStatusTypeIdRestriction?: number;
  maxRedeems?: number;
  name?: string;
  renewal?: boolean;
  subscriptionTypeIds?: Array<number>;
  upgrade?: boolean;
  value?: number;
}
